import { render, staticRenderFns } from "./TabNotations.vue?vue&type=template&id=af406546&scoped=true&"
import script from "./TabNotations.vue?vue&type=script&lang=js&"
export * from "./TabNotations.vue?vue&type=script&lang=js&"
import style0 from "./TabNotations.vue?vue&type=style&index=0&id=af406546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af406546",
  null
  
)

export default component.exports